export default "__VITE_ASSET__01463629__"